import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { ShoppingBag, Factory, Wine, Pickaxe, Cpu, Sprout } from "lucide-react";

const INDUSTRIES = [
    { icon: ShoppingBag, name: "Retail & FMCG", pain: "Tight margins, peak-season variability, multi-supplier sourcing.", win: "Lane benchmarking + invoice audit recovers margin without renegotiating prices." },
    { icon: Cpu, name: "Electronics & Tech imports", pain: "High-value cargo, tight launch windows, complex returns.", win: "Live visibility + customs orchestration protects launch dates and reduces holding cost." },
    { icon: Factory, name: "Industrial Manufacturing", pain: "Just-in-time inbound, project freight, oversized cargo.", win: "Routing intelligence and exception alerts keep production lines from waiting on the wharf." },
    { icon: Wine, name: "Wine & Agri exports", pain: "Reefer integrity, harvest-driven peaks, document-heavy compliance.", win: "Cold-chain visibility + Scope-3 reporting builds trust with global buyers." },
    { icon: Pickaxe, name: "Mining & Resources inputs", pain: "Bulk + project freight, remote site delivery, multi-modal coordination.", win: "Single view across sea + rail + road keeps inbound stock aligned to mine plans." },
    { icon: Sprout, name: "Agri & Food importers", pain: "Quarantine, BICON, perishability, exchange-rate exposure.", win: "Documentation orchestration and lane diversification limit clearance risk." },
];

export default function Industries() {
    return (
        <div data-testid="industries-page" className="bg-[#0A0A0E] text-zinc-100 min-h-screen">
            <Navbar />
            <main className="pt-28 pb-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl mb-14">
                    <span className="section-tag">Industries</span>
                    <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white mt-5 leading-[0.95] tracking-tighter">
                        Built for the way Australian trade actually moves.
                    </h1>
                    <p className="text-zinc-400 mt-6 leading-relaxed text-lg">
                        Each industry has its own freight reality. We tune the operating model
                        to yours — not the other way around.
                    </p>
                </div>

                <div className="grid lg:grid-cols-2 gap-4">
                    {INDUSTRIES.map((ind, i) => (
                        <article
                            key={ind.name}
                            data-testid={`industry-card-${i}`}
                            className="card-glow rounded-2xl p-7 lg:p-8"
                        >
                            <div className="flex items-start gap-5">
                                <div
                                    className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0"
                                    style={{
                                        background: "rgba(0,240,255,0.08)",
                                        border: "1px solid rgba(0,240,255,0.25)",
                                    }}
                                >
                                    <ind.icon size={20} className="text-cyan-300" />
                                </div>
                                <div>
                                    <h3 className="font-display text-xl sm:text-2xl text-white tracking-tight">
                                        {ind.name}
                                    </h3>
                                    <div className="mt-4">
                                        <div className="eyebrow">The pain</div>
                                        <p className="text-sm text-zinc-400 mt-1.5">{ind.pain}</p>
                                    </div>
                                    <div className="mt-4">
                                        <div className="eyebrow">Where we help</div>
                                        <p className="text-sm text-zinc-300 mt-1.5">{ind.win}</p>
                                    </div>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>

                <div className="mt-16 text-center">
                    <Link to="/demo" className="btn-primary" data-testid="industries-cta">
                        Book a 30-min industry walkthrough
                    </Link>
                </div>
            </main>
            <Footer />
        </div>
    );
}
